import { inject, Service } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { Role } from './roles';
import { AuthState } from '../state/auth.state';

@Service()
export class AuthService {
  private readonly oauthService: OAuthService = inject(OAuthService);
  private readonly authState: AuthState = inject(AuthState);

  isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  hasRole(role: Role): boolean {
    return this.authState.roles().includes(role);
  }

  login(): void {
    this.oauthService.redirectUri = window.location.origin + window.location.pathname;
    this.oauthService.initLoginFlow();
  }

  logout(): void {
    this.authState.clear();
    this.oauthService.logOut();
  }
}
